<app-navigation *ngIf="showNavbar"></app-navigation>
<div [@triggerName]="prepareRoute(outlet)">
    <router-outlet #outlet="outlet"></router-outlet>
</div>
